<template>
	<div class="container__registers">
		<label class="title_planning">{{
			`${$t('planningSiteClassification')} / ${item.descricao}`
		}}</label>
		<div class="container__main">
			<Card class="container__filtragem">
				<Filtragem
					:is-curva="Boolean(parcelaSitio.length)"
					:value="filtros"
					:set-loading="loading"
					:set-color="color"
					:esta-apenas-visualizando-o-resultado="isEdit == 'true'"
					@filtroConfig="setFiltroConfig($event)"
					@filtrar="filtrarParcelas"
					@processar="processar"
					@buscando="setBuscando"
					@limpandoFiltro="limpaFiltros"
					@filtrando="filtrando = $event"
				/>
			</Card>
			<Card
				v-if="modelagemStatus"
				:key="flag"
				class="container__dashboard__contentbody__card"
			>
				<div
					v-if="!agrupamentos?.length"
					class="flex h-full items-center justify-center"
				>
					<div v-if="filtrando">
						<Spinner />
					</div>
					<div
						v-else
						style="
							color: rgb(149, 187, 73);
							text-align: center;
							vertical-align: bottom;
							font-weight: 800;
						"
					>
						{{ agrupamentos ? $t('filtragemNaoRetornouDados') : $t('selecioneOsFiltros') }}
					</div>
				</div>
				<ScatterChart
					v-else
					:key="rerender"
					:select-on-zoom="selectArea"
					:mostrar-texto="isEdit"
					:maximo-variavel="maximoVariavelInteresse"
					class="main__parcels__chart"
					:idade-referencia="Number(item.clst_nr_idade_referencia)"
					:curvas="curvas"
					:series="agrupamentos"
					:tipo="variavelDeInteresse"
					:updated-at="buscando"
					@selectedPoints="selectedPoints"
					@tipoGrafico="tipoDoGrafico"
				>
					<template #action-buttons>
						<div class="action__buttons">
							<div class="action__buttons_left">
								<Button
									v-show="!flag"
									:label="`${$t('deleteSelected')}  ${parcelasTemporarias.length ? '( ' + parcelasTemporarias.length + ' )' : ''}`"
									color="trv-secondary"
									icon="far fa-trash-alt"
									semantic-class="tiny"
									:disabled="parcelasTemporarias.length === 0"
									width-auto
									@click="removeParcelasSelecionadas"
								/>

								<Button
									v-show="!flag"
									:label="$t('restoreDeleted')"
									color="trv-secondary"
									icon="fas fa-undo-alt"
									semantic-class="tiny"
									:disabled="parcelasBkp.length === parcelas.length"
									width-auto
									outlined
									@click="parcelas = parcelasBkp"
								/>

								<!-- <Checkbox
                  v-show="!flag"
                  id="checkbox__selecao__multipla"
                  v-model="selectArea"
                  label="Seleção Multipla"
                /> -->
							</div>
							<div class="action__buttons_right">
								<p>{{ quantidadeParcelas }} {{ $t('plots') }}</p>
								<p>{{ quantidadePlantios }} {{ $t('plantationswithiot') }}</p>
								<!-- <p >{{ new Set(agrupamentosClassificados.map(m => m.id)).size}} Agrupamentos</p> -->
								<Button
									v-show="flag"
									:label="$t('seeModel')"
									color="trv-primary"
									semantic-class="tiny"
									width-auto
									@click="modelagemStatus = false"
								/>
							</div>
						</div>
					</template>
				</ScatterChart>
				<div
					v-if="flag"
					class="container__histogramas__sitio"
				>
					<!-- <Histogramas :infoGrafico="tipoInfoGrafico" xTitulo="Número de Classes Diferentes" yTitulo="Quantidade" titulo="Classes Diferentes por Agrupamento" class="main__parcels__chart" :series="quantidadeClassesParcela"></Histogramas> -->
					<Coluna
						v-if="quantidadeClassesParcela && quantidadeClassesParcela.length"
						class="main__parcels__chart"
						:x-titulo="$t('diffClassesNumber')"
						:y-titulo="`${$t('quantity')} (%)`"
						:titulo="$t('diffClassesByGrouping')"
						:series="quantidadeClassesParcela"
					>
						<template #action-buttons>
							<Tooltip
								:titulo="$t('siteClassification')"
								:subtitulo="$t('diffClassesByGrouping')"
								:conteudo="$t('diffClassesByGroupingExplanation')"
							/>
						</template>
					</Coluna>

					<Coluna
						v-if="quantidadeMudancaClassesParcela && quantidadeMudancaClassesParcela.length"
						class="main__parcels__chart"
						:x-titulo="$t('classChangingNumber')"
						alt-x-titulo="Mudou de Classes"
						:y-titulo="`${$t('quantity')} (%)`"
						:titulo="$t('classChanging')"
						:series="quantidadeMudancaClassesParcela"
					>
						<template #action-buttons>
							<Tooltip
								:titulo="$t('siteClassification')"
								:subtitulo="$t('classChanging')"
								:conteudo="$t('classChangingExplanation')"
							/>
						</template>
					</Coluna>

					<Coluna
						v-if="quantidadeParcelaSitio && quantidadeParcelaSitio.length"
						class="main__parcels__chart"
						:x-titulo="$t('siteRate')"
						:y-titulo="`${$t('quantity')} (%)`"
						:titulo="$t('dataBySiteRate')"
						:series="quantidadeParcelaSitio"
					>
						<template #action-buttons>
							<Tooltip
								:titulo="$t('siteClassification')"
								:subtitulo="$t('dataBySiteRate')"
								:conteudo="$t('dataBySiteRateExplanation')"
							/>
						</template>
					</Coluna>
				</div>
			</Card>

			<Card v-else>
				<div class="model__preview__container">
					<ModelPreview
						:key="modeloEscolhido.stan_nm_variavel_modelo + modelos.indexOf(modeloEscolhido)"
						:tipo-info-grafico="tipoInfoGrafico"
						:model="modeloEscolhido"
						:preview-mode="flag"
						@back="fechaVisualizacaoModelo"
						@modeln="lidaEvento"
						@click="defineModelo"
					>
						<div class="model__preview_actions">
							<Button
								v-if="!flag"
								icon="fas fa-caret-left"
								:disabled="modeln == 0"
								class="btnnn"
								color="trv-primary"
								@click="anterior"
							/>
							<Button
								v-if="!flag"
								:id="model.stan_nm_variavel_modelo"
								class="btnVoltar"
								:loading="load"
								:label="`${$t('pickModel')} (${modeln + 1 + '/' + modelos.length})`"
								@click="defineModelo"
							/>
							<Button
								v-else
								:id="model.stan_nm_variavel_modelo"
								:label="$t('back')"
								@click="fechaVisualizacaoModelo"
							/>
							<Button
								v-if="!flag"
								id="btnProx"
								:disabled="modeln == modelos.length - 1"
								icon="fas fa-caret-right"
								class="btnnn"
								color="trv-primary"
								@click="proximo"
							/>
						</div>
					</ModelPreview>
				</div>
			</Card>

			<Card>
				<AboutModel
					v-show="!modelagemStatus"
					:key="variavelDeInteresse + modeloEscolhido.stan_nm_titulo_modelo"
					:modelo-escolhido="modeloEscolhido"
					:formula="formula"
				/>

				<div
					v-show="modelagemStatus"
					class="campos__parametrizacao"
				>
					<v-autocomplete
						v-model="modeloEscolhido"
						:disabled="disabledInput"
						:items="modelos"
						:label="$t('models')"
						item-text="stan_nm_titulo_modelo"
						item-value="stan_nm_variavel_modelo"
						return-object
						search
						outlined
						dense
						full-width
						clearable
						:allow-overflow="false"
						color="#081f44"
					>
						<template #item="{ item }">
							<v-list-item-content color="#081f44">
								<v-list-item-title v-html="item.stan_nm_titulo_modelo" />
								<v-list-item-subtitle
									v-html="`%${$t('error')}: ` + item.stan_md_erro_porcentagem.toFixed(3)"
								/>
							</v-list-item-content>
						</template>
					</v-autocomplete>
					<div class="container__compo_botao" />
					<v-text-field
						v-model="item.clst_nr_idade_referencia"
						:disabled="disabledInput"
						dense
						:label="`${$t('referenceAge')} ${$t('months')}`"
						type="number"
						outlined
						color="#081f44"
					/>
					<v-text-field
						v-model="item.clst_md_limite_superior"
						:disabled="disabledInput"
						dense
						:label="$t('upperLimit')"
						type="number"
						outlined
						color="#081f44"
					/>
					<v-text-field
						v-model="item.clst_md_limite_inferior"
						:disabled="disabledInput"
						dense
						:label="$t('lowerLimit')"
						type="number"
						outlined
						color="#081f44"
					/>
					<v-text-field
						v-model="item.clst_nr_curvas"
						:disabled="disabledInput"
						dense
						:label="$t('siteQuantity')"
						type="number"
						:value="curvas.length"
						outlined
						color="#081f44"
					/>
					<v-text-field
						v-model="item.clst_nr_amplitude_classes"
						:disabled="disabledInput"
						dense
						:label="$t('classBreadth')"
						type="number"
						outlined
						color="#081f44"
					/>

					<Button
						:disabled="disabledInput"
						:loading="loadClassificar"
						:label="$t('classifySite')"
						color="trv-primary"
						@click="classificar"
					/>

					<div class="container__button__classificar">
						<Button
							:disabled="disabledInput"
							:label="$t('save')"
							:loading="loadSalvar"
							@click="salvar"
						/>
					</div>
				</div>
			</Card>
			<!-- </div> -->
		</div>
	</div>
</template>
<script>
// import _ from "lodash"
import AboutModel from '../../../components/AboutModel/AboutModel.vue'
import Button from '../../../components/Button/Button'
import Card from '../../../components/Card/Card'
import ModelPreview from '../../../components/ModelPreview/ModelPreview'
import Filtragem from '../../../components/Prognose/Planejamento/Filtragem'
import ScatterChart from '../../../components/ScatterChart/ScatterChart'
import Spinner from '../../../components/Spinner/Spinner'
import Tooltip from '../../../components/Tooltip/Tooltip'
// import Checkbox from "../../../components/Checkbox/Checkbox";
// import Histogramas from "../../../components/Graficos/Histogramas.vue"
import { mapMutations } from 'vuex'
import Coluna from '../../../components/Graficos/Coluna.vue'

import {
	chooseModel,
	classificarSitio,
	getPlanejamentoClassificacao,
	salvarPlanejamento,
	sendProcessamento,
} from '../../../services/requests/ClassificacaoSitioRequests'
import modelos from '../../../services/responses/classificacaoSitio/modelos'
import { ModelosSitio } from '../../../utils/enums/NomeModelo'
import { sitio as variaveisBiometricas } from '../../../utils/variaveisBiometricas'
// import {Chart} from 'highcharts-vue'
export default {
	data() {
		return {
			filtrando: false,
			filtroConfig: {},
			sitios: [],
			isEdit: '',
			load: false,
			loadClassificar: false,
			loadSalvar: false,
			classeParcela: [],
			mudancaClasses: [],
			parcelaSitio: [],
			filtros: {
				ciclos: [],
				cidades: [],
				datasMedicao: [],
				datasPlantio: [],
				enableHistoricalData: [],
				espacamentos: [],
				especiesIds: [],
				estados: [],
				estratosIds: [],
				fazendasIds: [],
				idadesPlantio: [],
				isSingleTrees: false,
				manejos: [],
				materiaisGeneticos: [],
				paises: [],
				parcelasIds: [],
				plantiosIds: [],
				rotacoes: [],
				selectedDataPlantio: [],
				selectedIdadePlantio: [],
				talhoesIds: [],
				tiposServicos: [],
				variaveis: [],
			},
			rerender: true,
			booleanDisable: false,
			infoGrafico: {},
			tipoInfoGrafico: {
				// label: "Altura Dominante",
				// value: "alturaDominante",
				// acronimo: "H_DOM",
				// latex: "HDom",
				// unidade: "(m)",
			},
			flag: false,
			valuedisabled: false,
			equacao: true,
			selectArea: false,
			disableBuscar: false,
			// modeloInfo: undefined,
			interval: 60000,
			dadosModelo: [],
			modeloEscolhido: { stan_nm_variavel_modelo: 'default' },
			contador: undefined,
			modelosCalculados: [],
			loading: false,
			tt: '',
			valueSave: false,
			modelos: modelos.sort((a, b) =>
				a.stan_md_erro_porcentagem > b.stan_md_erro_porcentagem ? 1 : -1,
			),
			color: 'trv-default',
			item: {
				clst_nr_curvas: '',
				clst_nr_idade_referencia: '',
				clst_md_limite_superior: '',
				clst_md_limite_inferior: '',
				clst_nr_amplitude_classes: '',
			},
			buscando: '',
			parcelasTemporarias: [],
			parcelas: undefined,
			parcelasBkp: [],
			variavelDeInteresse: '',
			modeln: 0,
			colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'],
			disabledInput: true,
			modelagemStatus: true,
			showHistogramas: false,
			dropdownDownload: '',
			dropdownTipoGrafico: 'dispersaoParcelas',
			label: 'planejamento',
			estratos: [],
			model: 'tab-1',
		}
	},
	computed: {
		maximoVariavelInteresse() {
			return Math.max.apply(
				null,
				this.parcelas.map((m) => m[this.tipoInfoGrafico.value]),
			)
		},
		formula() {
			return (
				this.modeloEscolhido?.stan_nm_formula_modelo?.replaceAll(
					'variavelInteresse',
					this.tipoInfoGrafico?.latex,
				) ||
				'$$\\large variavelInteresse =\\beta_1 \\left(1-e^{\\beta _2I^{\\beta _3}}\\right)$$'.replaceAll(
					'variavelInteresse',
					this.tipoInfoGrafico?.latex,
				)
			)
		},
		quantidadeClassesParcela() {
			if (this.modeloInfo) {
				let d = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela
					.map((m) => m.quantidadeClasses)
					.reduce((acc, item) => {
						acc[item] = (acc[item] || 0) + 1
						return acc
					}, {})
				var total = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				var serie = Object.entries(d)

				serie.forEach((f) => {
					f[2] = (f[1] / total) * 100
					console.log(f)
				})

				return serie
			} else {
				return this.classeParcela
			}
		},

		/**
		 * Posicoes que são retornados nesta computed
		 * 0 = Indice de Sitio
		 * 1 = Quantidade no indice de sitio
		 * 2 = Porcentagem calculada
		 */
		quantidadeParcelaSitio() {
			let d = this.parcelaSitio.length
				? this.parcelaSitio
				: !this.modeloInfo
					? []
					: this.modeloInfo?.informacoesHistogramas?.quantidadeParcelaSitio.map((m) => [
							m.indiceSitio,
							m.quantidadeParcelas,
						])

			var total = 0
			d.forEach((indiceAtual) => {
				total += indiceAtual[1]
			})

			if (total != 0) {
				d.forEach((f) => {
					f[2] = (f[1] / total) * 100
					console.log('f23', this.quantidadeParcelas)
				})
			}

			return d
		},

		quantidadeMudancaClassesParcela() {
			if (this.modeloInfo) {
				let d = this.modeloInfo?.informacoesHistogramas?.quantidadeMudancaClassesParcela
					.map((m) => m.mudancasClasses)
					.reduce((acc, item) => {
						acc[item] = (acc[item] || 0) + 1
						return acc
					}, {})
				var total = this.modeloInfo?.informacoesHistogramas?.quantidadeClassesParcela.length
				var serie = Object.entries(d)

				serie.forEach((f) => {
					f[2] = (f[1] / total) * 100
					console.log(f)
					console.log('f2', total)
				})

				return serie
			} else {
				return this.mudancaClasses
			}
		},

		curvas() {
			return this.sitios.length
				? this.sitios
				: !this.modeloInfo
					? []
					: this.modeloInfo?.curvasSitio?.map((curva) => {
							return {
								tooltip: {
									positioner: function () {
										return { x: 40, y: 25 }
									},
									headerFormat: '<b>{point.codigoParcela}</b><br>',
									pointFormat:
										'Idade' +
										': {point.x:.0f} meses<br>' +
										this.tipoInfoGrafico.label +
										': {point.y:.3f} ' +
										this.tipoInfoGrafico.unidade.replace('(', '').replace(')', '') +
										'<br>' +
										this.tipoInfoGrafico.label +
										` referência : ${curva.identificador.toFixed(3)} ` +
										this.tipoInfoGrafico.unidade.replace('(', '').replace(')', ''),
								},
								type: 'spline',
								name: `Sítio: ${curva.identificador}`,
								data: curva.pontos
									.filter((f) => f.variavelBiometrica != 'Infinity')
									.map((ponto) => {
										return {
											x: ponto.idade,
											y: Number(ponto.variavelBiometrica.toFixed(2)),
										}
									}),
							}
						})
		},

		modeloInfo() {
			return !this.modeloEscolhido
				? undefined
				: this.dadosModelo.find(
						(modelo) => modelo.modelo === this.modeloEscolhido.stan_nm_variavel_modelo,
					)
		},

		indexChosenModel() {
			return !this.modeloEscolhido ? undefined : this.modelos.indexOf(this.modeloEscolhido)
		},

		preparaClassificacao() {
			return {
				parcelas: this.formatedParcelas,
				numeroClasses: isNaN(this.item.clst_nr_curvas) ? 5 : this.item.clst_nr_curvas,
				idadeReferencia: this.item.clst_nr_idade_referencia,
				limiteSuperior: this.item.clst_md_limite_superior,
				limiteInferior: this.item.clst_md_limite_inferior,
				// amplitudeClasse: this.item.clst_nr_amplitude_classes,
				modelos: this.modelos.map((modelo) => {
					return {
						coeficientes: modelo.parametros,
						nomeModelo: modelo.stan_nm_variavel_modelo,
						metodo: modelo.stan_nm_metodo_modelo,
					}
				}),
			}
		},

		formatedParcelas() {
			// Agrupa por parcelaId e idade para evitar duplicatas, mantendo apenas o primeiro registro
			const parcelasAgrupadas = Object.values(
				this.parcelas.reduce((acc, parcela) => {
					const chave = `${parcela.id}_${parcela.idade}`
					if (!acc[chave]) {
						acc[chave] = parcela
					}
					return acc
				}, {}),
			)

			return parcelasAgrupadas.map((parcela) => {
				return {
					parcelaId: parcela.id,
					idade: parcela.idade,
					variaveldeInteresse: parcela[this.tipoInfoGrafico.value],
				}
			})
		},

		limiteSuperior() {
			return Math.max.apply(
				null,
				this.modeloInfo ? this.modeloInfo.curvasSitio.map((m) => m.identificador) : [0],
			)
		},

		limiteInferior() {
			return Math.min.apply(
				null,
				this.modeloInfo ? this.modeloInfo.curvasSitio.map((m) => m.identificador) : [0],
			)
		},

		idadeMaxima() {
			return Math.max.apply(
				null,
				this.parcelas.map((parcela) => parcela.idade),
			)
		},

		quantidadeParcelas() {
			return [...new Set(this.parcelas.filter((el) => !el.isSingleTrees).map((m) => m.id))].length
		},

		quantidadePlantios() {
			return [...new Set(this.parcelas.filter((el) => el.isSingleTrees).map((p) => p.id))].length
		},

		agrupamentos() {
			return this.parcelas
		},

		unicas() {
			return [...new Set(this.parcelas.map((m) => m.id))]
		},

		preparaPlanejamento() {
			return {
				descricao: this.item.descricao,
				filtroDasAmostras: JSON.stringify(this.filtroConfig),
				dadosDoGrafico: JSON.stringify({
					agrupamentos: this.agrupamentos,
					sitios: this.curvas,
					quantidadeClassesParcela: this.quantidadeClassesParcela,
					quantidadeParcelaSitio: this.quantidadeParcelaSitio,
					quantidadeMudancaClassesParcela: this.quantidadeMudancaClassesParcela,
					realEstimado: this.modeloEscolhido.graficosModelo.realEstimado,
					residuo: this.modeloEscolhido.graficosModelo.residuo,
					histograma: this.modeloEscolhido.graficosModelo.histograma,
					equacao: {
						formula: this.modeloEscolhido.stan_formula_modelo,
						formulaTex: this.modeloEscolhido.stan_nm_formula_modelo,
						parametros: this.modeloEscolhido.parametros,
					},
				}),
				idadeDeReferencia: this.item.clst_nr_idade_referencia,
				limiteSuperior:
					!this.item.clst_md_limite_superior && !this.item.clst_md_limite_inferior
						? 2
						: this.item.clst_md_limite_superior,
				limiteInferior:
					!this.item.clst_md_limite_superior && !this.item.clst_md_limite_inferior
						? 1
						: this.item.clst_md_limite_inferior,
				quantidadeDeSitios:
					!this.item.clst_nr_curvas &&
					!this.item.clst_md_limite_superior &&
					!this.item.clst_md_limite_inferior
						? 1
						: this.item.clst_nr_curvas || 1,
				amplitudeDaClasse:
					!this.item.clst_nr_amplitude_classes &&
					!this.item.clst_md_limite_superior &&
					!this.item.clst_md_limite_inferior
						? 1
						: Math.round(this.item.clst_nr_amplitude_classes) || 1,
				coeficienteAssimetria: this.modeloEscolhido.stan_md_coeficiente_assimetria,
				coeficienteCurtose: this.modeloEscolhido.stan_md_coeficiente_curtose,
				erro: this.modeloEscolhido.stan_md_erro,
				erroPorcentagem: this.modeloEscolhido.stan_md_erro_porcentagem,
				r2Ajustado: this.modeloEscolhido.stan_md_r2ajustado,
				coeficientes: this.modeloEscolhido.parametros,
				variavelDeInteresse: variaveisBiometricas.find(
					(f) => f.value === this.tipoInfoGrafico.value,
				).enum, // Ajustar com ENUM
				nomeModelo: ModelosSitio[this.modeloEscolhido.stan_nm_variavel_modelo], // Ajustar com ENUM
			}
		},
	},
	watch: {
		selectArea(e) {
			console.log(e)
			this.rerender = !this.rerender
			if (e == false) {
				this.parcelasTemporarias.length = 0
			}
		},
		modeloEscolhido() {
			this.modeln =
				this.modelos.indexOf(this.modeloEscolhido) === -1
					? 0
					: this.modelos.indexOf(this.modeloEscolhido)
			this.parcelas = this.agrupamentos
			this.item.clst_md_limite_superior = this.limiteSuperior
			this.item.clst_md_limite_inferior = this.limiteInferior
		},

		'item.clst_md_limite_superior': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_md_limite_inferior': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_nr_curvas': function () {
			this.item.clst_nr_amplitude_classes =
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
				Number(this.item.clst_nr_curvas)
		},

		'item.clst_nr_amplitude_classes': function () {
			this.item.clst_nr_curvas = Math.round(
				(Number(this.item.clst_md_limite_superior) - Number(this.item.clst_md_limite_inferior)) /
					Number(this.item.clst_nr_amplitude_classes),
			)
		},
	},
	async created() {
		this.isEdit = localStorage.getItem('isEdit', this.isEdit)

		if (this.quantidadeParcelaSitio.length < 0) {
			this.booleanDisable = true
		}

		this.item = Object.assign(
			JSON.parse(localStorage.getItem('item-planejamento-classificacao')),
			this.item,
		)
		let pathnamearr = window.location.pathname.split('/')

		await getPlanejamentoClassificacao(pathnamearr[pathnamearr.length - 1])
			.then((response) => {
				this.filtros = JSON.parse(response.data.filtroDasAmostras)

				let dadosGrafico = JSON.parse(response.data.dadosDoGrafico)
				this.parcelas = dadosGrafico.agrupamentos
				this.sitios = dadosGrafico.sitios
				this.classeParcela = dadosGrafico.quantidadeClassesParcela
				this.mudancaClasses = dadosGrafico.quantidadeMudancaClassesParcela
				this.parcelaSitio = dadosGrafico.quantidadeParcelaSitio

				this.item.clst_md_limite_superior = response.data.limiteSuperior
				this.item.clst_md_limite_inferior = response.data.limiteInferior
				this.item.clst_nr_idade_referencia = response.data.idadeDeReferencia
				this.item.clst_nr_curvas = response.data.quantidadeDeSitios

				this.modeloEscolhido.stan_nm_titulo_modelo = response.data.tituloDoModelo
				this.modeloEscolhido.stan_md_erro_porcentagem = response.data.erroPorcentagem
				this.modeloEscolhido.stan_md_erro = response.data.erro
				this.modeloEscolhido.stan_md_coeficiente_assimetria = response.data.coeficienteAssimetria
				this.modeloEscolhido.stan_md_coeficiente_curtose = response.data.coeficienteCurtose
				this.modeloEscolhido.stan_nm_variavel_modelo = 'toDo'
				this.modeloEscolhido.graficosModelo = {
					realEstimado: dadosGrafico.realEstimado,
					histograma: dadosGrafico.histograma,
					residuo: dadosGrafico.residuo,
				}

				this.modeloEscolhido.parametros = dadosGrafico.equacao.parametros
				this.modeloEscolhido.stan_nm_formula_modelo = dadosGrafico.equacao.formulaTex
				this.variavelDeInteresse = this.converterVariavel(response.data.variavelDeInteresse)

				// this.modelos = [this.modeloEscolhido];

				this.flag = !this.flag
			})
			.catch((error) => {
				if (error.response.status === 400)
					console.log(
						'Esta é uma classificação nova, não existe classificação de sítio para ser exibida!',
					)
			})
	},

	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		setFiltroConfig(e) {
			console.log(e)
			this.filtroConfig = e
		},
		salvar() {
			this.loadSalvar = true
			// createClassificacaoSitio({ Descricao: this.item.descricao }).then(res => console.warn(res))
			salvarPlanejamento(this.preparaPlanejamento)
				.then(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: this.$t('planejamentoRealizadoComSucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					this.$router.push('/classificacao')
				})
				.catch((res) => console.warn(res))
		},

		converterVariavel(variavel) {
			const mapeamento = {
				'Diâmetro Médio Quadrático': 'diametroMedioQuadratico',
				'Altura Dominante': 'alturaDominante',
				'DAP Máximo': 'dapMaximo',
				'Volume Arvore Media com Casca': 'volumeIndividualComCasca',
				'Volume Total Com Casca': 'volumeTotalComCasca',
				'Área Basal': 'areaBasal',
			}
			return mapeamento[variavel] || variavel
		},

		proximo() {
			this.modeln += 1
			this.modeloEscolhido = this.modelos[this.modeln]
		},
		anterior() {
			this.modeln = this.modeln - 1
			this.modeloEscolhido = this.modelos[this.modeln]
		},
		equa(event) {
			this.equacao = event
		},
		lidaEvento(event) {
			console.log('eventt', event)
			this.modeln = event
		},
		async classificar() {
			this.loadClassificar = true
			var res = await classificarSitio(this.preparaClassificacao)
			console.warn(res)
			this.dadosModelo = res.data.result
			if (this.dadosModelo) {
				this.loadClassificar = false
			}
			this.rerender = !this.rerender
			this.item.clst_nr_curvas = res.data.result[0].curvasSitio.length - 1
		},
		fechaVisualizacaoModelo() {
			this.flag = true
			this.equacao = true
			this.modelagemStatus = true
		},
		selectedPoints(value) {
			this.parcelasTemporarias = value
			console.log(value)
		},
		setBuscando(value) {
			this.buscando = value
		},
		tipoDoGrafico(value) {
			this.tipoInfoGrafico = value
			this.variavelDeInteresse = value.value
		},
		removeParcelasSelecionadas() {
			let testeParcelas = []
			this.parcelasTemporarias.forEach((e) => {
				this.parcelas.forEach((o) => {
					if (o.idade === e[0] && o[this.variavelDeInteresse] === e[1]) testeParcelas.push(o)
				})
			})

			this.parcelas = this.parcelas.filter((parcela) => !testeParcelas.includes(parcela))
			this.parcelasTemporarias = []
		},
		escolhaModelos() {
			this.modelagemStatus = false
		},
		async defineModelo() {
			this.load = true
			var parcelasFiltradas = this.preparaClassificacao.parcelas.filter(
				(a) => a.variaveldeInteresse !== null,
			)
			const preparaClassificacaoTratado = {
				...this.preparaClassificacao,
				parcelas: parcelasFiltradas,
			}
			const res = await chooseModel(preparaClassificacaoTratado)
			this.disableBuscar = false
			this.equacao = true
			this.disabledInput = false
			this.dadosModelo = res.data.result

			this.modeloEscolhido = this.modelos[this.modeln]
			this.modelagemStatus = true
			this.showHistogramas = true
			this.flag = true
			this.item.clst_md_limite_superior = this.limiteSuperior
			this.item.clst_md_limite_inferior = this.limiteInferior
			this.item.clst_nr_idade_referencia = 84
			this.item.clst_nr_curvas = 5
		},
		async filtrarParcelas(value) {
			let retornar = false
			if (!this.modelagemStatus || this.flag)
				retornar = confirm('Isso fará com que o processo retorne ao início')
			if (retornar) {
				this.modelagemStatus = true
				this.flag = false
				this.modelos = []
				this.modeloEscolhido = { stan_nm_variavel_modelo: 'default' }
				this.modeln = 0
				this.item.clst_nr_curvas = 5
			}

			this.parcelas = value
			this.parcelasBkp = value
			// this.item.clst_md_limite_superior = Number(this.limiteSuperior);
			// this.item.clst_md_limite_inferior = Number(this.limiteInferior);
			this.item.clst_nr_idade_referencia = ''
			this.load = false
			this.disabledInput = true
		},
		equac() {
			this.equacao = false
		},
		async processar() {
			// Filtra parcelas válidas e agrupa por idade para evitar duplicatas
			const parcelasValidas = this.parcelas.filter(
				(agrupamento) => !isNaN(parseFloat(agrupamento[this.variavelDeInteresse])),
			)

			// Agrupa por parcelaId e idade, mantendo apenas o primeiro registro de cada grupo
			const parcelasAgrupadas = Object.values(
				parcelasValidas.reduce((acc, agrupamento) => {
					const chave = `${agrupamento.id}_${agrupamento.idade}`
					if (!acc[chave]) {
						acc[chave] = agrupamento
					}
					return acc
				}, {}),
			)

			const res = await sendProcessamento({
				Parcelas: parcelasAgrupadas.map((agrupamento) => ({
					parcelaId: agrupamento.id,
					idade: agrupamento.idade,
					variavelDeInteresse: parseFloat(agrupamento[this.variavelDeInteresse]),
				})),
			})

			if (res.status === 200) {
				this.modelagemStatus = false
				this.loading = true
				this.equacao = false
				this.modelos = res.data.result.sort((a, b) =>
					a.stan_md_erro_porcentagem > b.stan_md_erro_porcentagem ? 1 : -1,
				)
				this.modeloEscolhido = res.data.result[this.modeln]
			}
		},
		limpaFiltros() {
			this.load = false
		},
	},
	components: {
		Card,
		Button,
		Filtragem,
		ScatterChart,
		ModelPreview,
		Tooltip,
		Spinner,
		// Checkbox,
		// Histogramas,
		Coluna,
		AboutModel,
	},
}
</script>

<style scoped>
.container__button__classificar {
	/* display: grid;
  gap: 1rem; */
	width: 100%;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 3.8rem 1rem;
}

.campos__parametrizacao {
	margin-top: 2rem;
	padding: 0 0.8rem;
	position: relative;
	/* display: flex; */
	/* flex-direction: column; */
	justify-content: space-between;
	height: 100%;
	box-sizing: border-box;
}

/* .v-item-group {
  position: absolute !important;
} */

.container__card.container__dashboard__contentbody__card {
	margin: 0;
	display: flex;
	flex-direction: column;
}

.btnVoltar {
	width: auto;
}

.title_planning {
	font-size: 1rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}

.container__compo_botao {
	display: flex;
}

.divBubble {
	text-align: end;
	position: inherit;
	margin-left: -70px;
}

.model__preview_actions {
	padding: 0.8rem;
	display: flex;
	align-content: center !important;
}

.container__histogramas__sitio {
	display: flex;
	flex-direction: row;
	height: 100%;
}

.container__registers {
	padding: 0.8rem;
	height: 90vh;
}

.btnnn {
	align-content: center;
}

.btnnn:active {
	background-color: #0b0e25;
	transform: translateY(-1px);
}

.container__main {
	display: grid;
	width: 100%;
	height: 100%;
	max-height: 100%;
	gap: 0.5rem;
	margin-top: 0.5rem;
	/* justify-content: space-between; */
	grid-template-columns: 1fr 3fr 1fr;
}

.action__buttons_right,
.action__buttons_left {
	display: flex;
	gap: 0.5rem;
}

.container__card__custom.steps {
	max-height: 3rem;
	background: none;
}

.v-stepper__header {
	height: 3rem;
}

.v-stepper__step {
	padding: 0.5rem 0.8rem;
}

.v-devider {
	padding: 0 1rem;
}

/* .v-window.v-item-group.theme--dark.v-carousel {
    height: 100%;
} */

/* .v-window.v-item-group.theme--light.v-tabs-items {
  height: 95%;
} */

.model__preview__container {
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	justify-content: space-evenly;
}

.container__cardgrafico.main__parcels__chart {
	height: 100%;
}

/* .container__filtragem {
  position: relative;
} */

.container__dropdown__label {
	margin-bottom: 0 !important;
}

.v-window__container {
	width: 100% !important;
	height: 95% !important;
}

.ui.button {
	padding: 8px 15px;
}

.action__buttons {
	padding: 0 0 0.5rem 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.ccontainer__checkbox {
	padding: 0.5rem 0;
}
</style>
